<template>
  <div id="app">
    <a-config-provider :locale="zh_CN">
    <router-view/>
    </a-config-provider>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
  import 'moment/locale/zh-cn';

  moment.locale('zh-cn');
export default {
  name: 'App',
  data(){
     return {
      zh_CN
    }
  }
  
}
</script>

<style>
html,body{
  margin:0;
  padding:0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.good_list .goods .goods_pic img{
  width:100%;
  height:100%;
  border-radius:5px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue